import { useState } from 'react';

import { EventForUser } from '../../../../types';

/**
 * Manages the state of accepted waivers for an event.
 */
const useWaivers = (event: EventForUser) => {
  const [totalCheckedWaivers, setTotalCheckedWaivers] = useState(0);
  const data = event?.waivers || [];

  const allWaiversAccepted = totalCheckedWaivers === data.length;

  return {
    data,
    totalCheckedWaivers,
    setTotalCheckedWaivers,
    allWaiversAccepted
  };
};

export default useWaivers;
